import React from 'react'
import PropTypes from 'prop-types'

const PageHeader = (props) => (
  <div>
    { !props.homePage ?
      <section className="section section--pattern--light">
        <div className="container">
          <div style={{ cursor: 'pointer' }}>
            <h1 className="softinBlue-text section--pageHeader__text">
              {props.title}
              {props.subtitle}
            </h1>
          </div>
        </div>
      </section>
      :
      <section className="section section--pattern--blue p-md-5">
        <div className="container my-md-5">
          <div className="w-md-50 mx-md-auto text-white text-center">
            <h4> {props.title} </h4>
            <p className="font-weight-bold">Com o sistema de indicações do Gravíttem é possível ganhar <br className="d-none d-md-block" /> até <span style={{ color: '#FFC621' }}>35% de desconto</span> em cada mensalidade!</p>
          </div>
        </div>
      </section>
    }
  </div>
)

PageHeader.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  homePage: PropTypes.string,
}

export default PageHeader



// WEBPACK FOOTER //
// ./client/components/PageHeader.js